module.exports = __webpack_public_path__ + "img/switch.9f49825c.svg";